var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDeleteByIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3H11V4H10V10.5C10 10.7761 9.77615 11 9.5 11H2.5C2.22386 11 2 10.7761 2 10.5V4H1V3H3.5V1.5C3.5 1.22386 3.72386 1 4 1H8C8.27615 1 8.5 1.22386 8.5 1.5V3ZM9 4H3V10H9V4ZM6.7071 6.99985L7.591 7.88375L6.8839 8.59085L6 7.70695L5.1161 8.59085L4.40901 7.88375L5.2929 6.99985L4.40901 6.116L5.1161 5.4089L6 6.29275L6.8839 5.4089L7.591 6.116L6.7071 6.99985ZM4.5 2V3H7.5V2H4.5Z",
    fill: "#1B1F1E"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDeleteByIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/DeleteByIcon.dc1f62cb.svg";
export { ForwardRef as ReactComponent };